import styled from 'styled-components';
import { Body5, Container, Page } from '@ui';
import React from 'react';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { FlatButton } from '@ui/buttons';
import { sendApiDownloadRequest } from '@services/api';
import { logNetRequest } from '@utils/usefulFuncs';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';

const PageWrapper = styled.div`
  + div {
    width: 100%;
  }
`;
const FormWrapper = styled.div`
  width: 100%;

  input {
    padding: 8px 16px;
    width: 100%;
  }
`;

export default function TemplateRedownload({}) {
  const navigate = useNavigate();
  const [id, setId] = React.useState('');
  const [modeId, setModeId] = React.useState('');
  const [urlParams, setUrlParams] = React.useState('');
  const [formError, setFormError] = React.useState(null);

  const onDownloadTemplate = async () => {
    try {
      const filename = 'GeneratedReport' + '-' + modeId + '-' + id;
      let URL = `v1/genai/templates/filled/${modeId}/${id}`;
      if (urlParams !== '') {
        URL = `v1/genai/templates/filled/${modeId}/${id}?${urlParams}`;
      }
      const response = await sendApiDownloadRequest(URL);
      const { status, data, error } = response;
      logNetRequest(status, data, URL);
      if (status === 200) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setFormError(error || 'Something went wrong downloading the file, please try again later.');
      }
    } catch (error) {
      setFormError(error || 'Something went wrong downloading the file, please try again later.');
      console.error('Error downloading the file:', error);
    }
  };

  const onGoBack = () => {
    navigate(ROUTES.home);
  };
  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width={'500px'}>
          <BackArrowButton onClick={onGoBack} />
          <Container top={40}>
            <FormWrapper>
              <Container top={24}>
                <input value={id} onChange={(e) => setId(e.target.value)} placeholder="Enter ID" />
              </Container>
              <Container top={24}>
                <input value={modeId} onChange={(e) => setModeId(e.target.value)} placeholder="Enter Mode ID" />
              </Container>
              <Container top={24}>
                <input value={urlParams} onChange={(e) => setUrlParams(e.target.value)} placeholder="URL Params" />
              </Container>
              {formError && (
                <Container top={24}>
                  <Body5>{formError}</Body5>
                </Container>
              )}
              <Container top={40}>
                <FlatButton onClick={onDownloadTemplate} fullWidth>
                  Download Template
                </FlatButton>
              </Container>
            </FormWrapper>
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}
